import { render, staticRenderFns } from "./CollectionUserAccountUpdateModule.vue?vue&type=template&id=007b2a98"
import script from "./CollectionUserAccountUpdateModule.vue?vue&type=script&lang=js"
export * from "./CollectionUserAccountUpdateModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports